import { SectionHeader } from '@core/components';
import { Text, Heading, Badge, BadgeSize, BadgeVariant, Icon, IconSize, LockSolid, Block, QrCode, Card, ApplicationLaunch } from '@soteria/design-system-ve';

import * as styles from './ActionAuthenticationSection.css';

export function ActionAuthenticationSection() {
  return (
    <div className={styles.sectionContainer}>
      <SectionHeader
        description="Callback authentication ensures that incoming webhook requests to your application are legitimate and originate from the platform."
        title="Action Authentication"
      />

      <Card padding="none">
        <div className={styles.cardContent}>
          <div className={styles.columnsGrid}>
            {/* JWT Token Validation Column */}
            <div className={styles.column}>
              <div className={styles.columnHeader}>
                <div className={styles.iconContainer}>
                  <Icon icon={LockSolid} iconSize={IconSize.Medium} />
                </div>
                <Heading className={styles.columnTitle} level="h3">
                  JWT Token Validation
                </Heading>
              </div>
              <Text className={styles.columnDescription}>
                Validates JWT tokens in callback request headers and contains claims about request authenticity and context.
              </Text>
            </div>

            {/* Azure AD Integration Column */}
            <div className={styles.column}>
              <div className={styles.columnHeader}>
                <div className={styles.iconContainer}>
                  <Icon icon={Block} iconSize={IconSize.Medium} />
                </div>
                <Heading className={styles.columnTitle} level="h3">
                  Azure AD Integration
                </Heading>
              </div>
              <Text className={styles.columnDescription}>
                Fetches public keys from Azure AD JWKS endpoint for cryptographic verification using configured tenant and client IDs.
              </Text>
            </div>

            {/* SDK Libraries Column */}
            <div className={styles.column}>
              <div className={styles.columnHeader}>
                <div className={styles.iconContainer}>
                  <Icon icon={QrCode} iconSize={IconSize.Medium} />
                </div>
                <Heading className={styles.columnTitle} level="h3">
                  SDK Libraries
                </Heading>
              </div>
              <Text className={styles.columnDescription}>
                Simple APIs for token validation with helper functions for HTTP headers and easy integration into existing applications.
              </Text>
              <div className={styles.linksContainer}>
                <Badge
                  href="https://microsoft.visualstudio.com/STaR/_artifacts/feed/ProjectSpring/NuGet/ProjectSpring.Callback.Auth.Net/overview"
                  icons={[ApplicationLaunch]}
                  size={BadgeSize.Medium}
                  text="NuGet Package"
                  variant={BadgeVariant.Success}
                />
                <Badge
                  href="https://microsoft.visualstudio.com/STaR/_artifacts/feed/ProjectSpring/Npm/@soteria%2Fcallback-auth/overview"
                  icons={[ApplicationLaunch]}
                  size={BadgeSize.Medium}
                  text="NPM Package"
                  variant={BadgeVariant.Success}
                />
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
